import { coalescedGet, http } from "@/lib/http";
import type { SignalConfig } from "@/features/signals/types";
import type { DashboardWidget } from "@/features/widgets/types";

export interface SharedDashboardLayout {
  exists: boolean;
  workspaceId: string;
  machineId: string;
  configVersion: string | null;
  widgets: DashboardWidget[];
  signalConfigs: SignalConfig[];
  updatedAt: string | null;
}

function layoutPath(workspaceId: string, machineId: string): string {
  return `/api/workspaces/${encodeURIComponent(workspaceId)}/machines/${encodeURIComponent(machineId)}/layout`;
}

function configQuery(configVersion?: string | null): string {
  const version = configVersion?.trim();
  if (!version) return "";
  return `?${new URLSearchParams({ configVersion: version })}`;
}

export function getSharedDashboardLayout(
  workspaceId: string,
  machineId: string,
  configVersion?: string | null,
  signal?: AbortSignal,
): Promise<SharedDashboardLayout> {
  return coalescedGet<SharedDashboardLayout>(
    `${layoutPath(workspaceId, machineId)}${configQuery(configVersion)}`,
    signal,
  );
}

export function saveSharedDashboardWidgets(
  workspaceId: string,
  machineId: string,
  configVersion: string | null | undefined,
  widgets: DashboardWidget[],
): Promise<SharedDashboardLayout> {
  return http.put<SharedDashboardLayout>(
    `${layoutPath(workspaceId, machineId)}/widgets`,
    { configVersion: configVersion ?? null, widgets },
  );
}

export function saveSharedSignalConfigs(
  workspaceId: string,
  machineId: string,
  configVersion: string | null | undefined,
  signalConfigs: SignalConfig[],
): Promise<SharedDashboardLayout> {
  return http.put<SharedDashboardLayout>(
    `${layoutPath(workspaceId, machineId)}/signal-configs`,
    { configVersion: configVersion ?? null, signalConfigs },
  );
}
